module.exports = __webpack_public_path__ + "static/45-188c9fcbf7d03c76f1d81fd500c4fa5f.png";